import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import Box from '../Box/Box';
import parentName from './name';
import TTextField from './@types/TextField';

type TTextFieldInputMultiLine = TTextField & {
  defaultValue?: string;
  minRows: number;
  maxRows: number;
};

// eslint-disable-next-line react/display-name
const TextFieldInputMultiLine = React.forwardRef(
  ({ id, isRequired, onChange, defaultValue, minRows, maxRows, name, ...rest }: TTextFieldInputMultiLine, ref) => (
    <Box
      {...rest}
      parent={parentName}
      name="input"
      minRows={minRows}
      maxRows={maxRows}
      modifiers={['multiline']}
      onChange={onChange}
      as={TextareaAutosize as any}
      id={id}
      htmlNameAttr={name || id}
      ref={ref}
      required={isRequired}
      defaultValue={defaultValue}
    />
  ),
);

export default TextFieldInputMultiLine;
